import { render, staticRenderFns } from "./my.vue?vue&type=template&id=10fff340&scoped=true&"
import script from "./my.vue?vue&type=script&lang=ts&"
export * from "./my.vue?vue&type=script&lang=ts&"
import style0 from "./my.vue?vue&type=style&index=0&id=10fff340&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10fff340",
  null
  
)

export default component.exports